export default "/shell-eth-icon.63abec7052a99b0a6daa412d529c3831.png";